var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Grid, MenuItem, TextField, Typography } from '@material-ui/core';
import { EntityTextField } from '../../common/EntityTextField';
export const EntitySampleBooleanConfigurator = props => {
    const { column, config, disabled, validate, onChange } = props;
    const errors = (validate === null || validate === void 0 ? void 0 : validate(config, column)) || {};
    const renderInput = (type) => {
        const label = type.toString();
        const percent = (typeof config.percent === 'number'
            ? type
                ? config.percent
                : 100 - config.percent
            : '').toString();
        return (React.createElement(TextField, { fullWidth: true, size: 'small', type: 'number', variant: 'outlined', label: label, value: percent, disabled: disabled, error: !!errors.percent, InputProps: {
                startAdornment: (React.createElement(Typography, { color: 'textSecondary', style: { marginRight: 6 } }, "%"))
            }, helperText: errors.percent || (React.createElement(React.Fragment, null,
                "Set the random percentage for ",
                React.createElement("strong", null, label))), onChange: event => {
                if (!event.target.value) {
                    onChange === null || onChange === void 0 ? void 0 : onChange({ percent: undefined });
                    return;
                }
                const value = parseInt(event.target.value);
                if (isFinite(value) && value >= 0 && value <= 100) {
                    onChange === null || onChange === void 0 ? void 0 : onChange({ percent: type ? value : 100 - value });
                }
            } }));
    };
    return (React.createElement(Grid, { container: true, spacing: 2 },
        React.createElement(Grid, { item: true, xs: 12, sm: 6 }, renderInput(true)),
        React.createElement(Grid, { item: true, xs: 12, sm: 6 }, renderInput(false))));
};
export const EntityBooleanField = (_a) => {
    var { value, plugin, onChange } = _a, props = __rest(_a, ["value", "plugin", "onChange"]);
    return (React.createElement(EntityTextField, Object.assign({}, props, { select: true, value: value ? 'true' : 'false', plugin: plugin, onChange: value => {
            onChange === null || onChange === void 0 ? void 0 : onChange(value === 'true');
        } }),
        React.createElement(MenuItem, { value: 'false' }, "False"),
        React.createElement(MenuItem, { value: 'true' }, "True")));
};
export const EntityBooleanPlugin = {
    type: 'boolean',
    edit: {
        field: EntityBooleanField
    },
    sampleData: {
        configurator: EntitySampleBooleanConfigurator,
        defaultValue: () => ({ percent: 50 }),
        validate: config => {
            const percent = typeof config.percent !== 'number' ? 'Percent is required.' : undefined;
            return percent ? { percent } : undefined;
        }
    }
};
//# sourceMappingURL=EntityBooleanPlugin.js.map